export const userNameErrorMessage = 
  "Username should contains 10 digit mobile number or character(including @ and underscore)";
export const passwordErrorMessage = "Password should contains only character";
